import { render, staticRenderFns } from "./FamilyDetails.vue?vue&type=template&id=77c3c3c6&scoped=true&"
import script from "./FamilyDetails.vue?vue&type=script&lang=js&"
export * from "./FamilyDetails.vue?vue&type=script&lang=js&"
import style0 from "./FamilyDetails.vue?vue&type=style&index=0&id=77c3c3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c3c3c6",
  null
  
)

export default component.exports